import { render, staticRenderFns } from "./Umana.vue?vue&type=template&id=1699bc40&scoped=true&"
import script from "./Umana.vue?vue&type=script&lang=js&"
export * from "./Umana.vue?vue&type=script&lang=js&"
import style0 from "./Umana.vue?vue&type=style&index=0&id=1699bc40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1699bc40",
  null
  
)

export default component.exports